import { useMemo } from "react";

import { CustomField } from "@every.org/common/src/codecs/donationFlowCustomization";

const normalizeCustomFieldHeading = (heading: string) => {
  const normalized = heading
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

  return normalized || "field";
};

export type DonateCustomField = CustomField & {
  formKey: string;
};

export const useDonateCustomFields = (customFields?: CustomField[]) =>
  useMemo<DonateCustomField[] | undefined>(() => {
    if (!customFields?.length) {
      return undefined;
    }

    const keyCounts = new Map<string, number>();

    return customFields.map((field) => {
      const normalizedHeading = normalizeCustomFieldHeading(field.heading);
      const count = (keyCounts.get(normalizedHeading) || 0) + 1;
      keyCounts.set(normalizedHeading, count);
      const suffix = count > 1 ? `_${count}` : "";

      return {
        ...field,
        formKey: `customField_${normalizedHeading}${suffix}`,
      };
    });
  }, [customFields]);
